module.exports = __webpack_public_path__ + "static/media/How to change my email signature.082515c9.png";